<template>
    <div id="loadingModal" class="loading-modal" v-show="loading">
        <div class="loading-spinner"></div>
    </div>
</template>

<script>
export default{
    props:{
        loading:{
            type: Boolean
        }
    }
}
</script>

<style scoped>
 .loading-modal {
    display: none; /* ซ่อนไว้ก่อน */
    position: fixed;
    z-index: 9999;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0, 0, 0, 0.5); /* ฉากหลังดำโปร่ง */
    display: flex;
    justify-content: center;
    align-items: center;
  }

  .loading-spinner {
    width: 50px;
    height: 50px;
    border: 5px solid #f3f3f3;
    border-top: 5px solid #00fd61; /* สีหมุน */
    border-radius: 50%;
    animation: spin 1s linear infinite;
  }

  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }
</style>